/* eslint-disable tss-unused-classes/unused-classes -- classes are used via returned object from makeStyles hook */
import { makeStyles } from 'tss-react/mui';
export type BalanceSheetRowVariant = 'contents' | 'stickyHeader';
export interface BalanceSheetRowStyleProps {
  /**
   * Whether hover state should be enabled (disabled in presentation/export contexts)
   */
  enableHover: boolean;
  /**
   * 'contents' (default): children become direct grid items of the parent grid.
   * 'stickyHeader': row generates a real CSS box with subgrid, enabling position: sticky.
   */
  variant: BalanceSheetRowVariant;
  /**
   * The top offset (in px) for sticky positioning. Only used when variant is 'stickyHeader'.
   */
  stickyTop: number;
}
export const BALANCE_SHEET_ROW_CLASSNAME = 'balanceSheetRow';
export const BALANCE_SHEET_ROW_SHOW_ON_HOVER_CLASSNAME = 'balanceSheetRowShowOnHover';
export const useBalanceSheetRowStyles = makeStyles<BalanceSheetRowStyleProps>()((theme, {
  enableHover,
  variant,
  stickyTop
}) => ({
  root: {
    ...(variant === 'stickyHeader' ? {
      // subgrid lets this row generate a CSS box (enabling position: sticky)
      // while inheriting column tracks from the parent grid.
      display: 'grid',
      gridTemplateColumns: 'subgrid',
      gridColumn: '1 / -1',
      position: 'sticky',
      top: stickyTop,
      zIndex: 2,
      backgroundColor: theme.palette.background.paper
    } : {
      // display: contents makes children become direct grid items of the
      // parent grid, ensuring all rows share the same column tracks.
      // The element stays in the DOM for hover detection.
      display: 'contents'
    }),
    ...(enableHover && {
      [`& .${BALANCE_SHEET_ROW_SHOW_ON_HOVER_CLASSNAME}`]: {
        display: 'none'
      },
      '&:hover': {
        [`& .${BALANCE_SHEET_ROW_SHOW_ON_HOVER_CLASSNAME}`]: {
          display: 'initial'
        }
      }
    })
  }
}));